import { useMutation } from '@tanstack/react-query';
import { fetchServiceability } from '../api/delivery-api.js';

/**
 * Serviceability is checked on-demand (a "Check" button next to a pincode
 * input), not on a query key someone else shares -- a mutation fits that
 * request/response shape better than a `useQuery` that would need an
 * `enabled` gate keyed off input state.
 */
export function useServiceabilityCheck() {
  return useMutation({
    mutationFn: (pincode: string) => fetchServiceability(pincode),
  });
}
